module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("THE DEATH WAVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Jordan stared down at Halleck, seated beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Faster than light? That’s impossible. Nothing in the universe can travel faster than light.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("One of the Europeans, short, stocky, swarthy, with a thick shock of jet-black hair, wearing a dark, slightly rumpled business suit, lumbered to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I am an astrophysicist … or, at least, I was an astrophysicist before I was appointed to membership in this council.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A wave of rueful chuckles spread around the table. Most of the Council members had stepped away from careers in business or science or academia to take on the responsibilities of the World Council. While it was possible to run for Council membership in an open election, most Council members were selected by a computer-directed lottery; to refuse the honor was not permitted, except under the most exigent circumstances. Hardly any of the Council members had been professional politicians, although that is what they had inevitably become. And their staffs had plenty of lifetime politicians working behind the scenes.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Halleck said, “Professor Rudaki. Your daughter is still on New Earth, isn’t she?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("With a blunt nod, Rudaki answered, “Yes. My Elyse is studying the white dwarf star, Sirius B.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The Pup,” Halleck murmured. Jordan thought she did it to show that she was not entirely ignorant of astronomical jargon.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Rudaki ignored it. To Jordan, he said, “While Einstein showed that no body containing mass can exceed the velocity of light, there is no such restriction for information.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan knew where he was heading.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jabbing a stubby finger in Jordan’s direction, the astrophysicist continued, “You tell us that these aliens of New Earth have warned that a wave of intense gamma radiation is heading toward us.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, the result of a massive gamma burst in the core of the Milky Way nearly thirty thousand years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The front of this wave is two thousand light-years away from us.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And heading toward us at the speed of light.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“How do the aliens know of this?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“They’ve observed it,” Jordan replied. “From planets closer to the core of the galaxy, where the explosion occurred.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Exactly. And if this wave destroys all life, who would be left alive to report on it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The death wave destroys all "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("organic")]), _vm._v(" life. But the aliens who observed it were not organic. They were intelligent machines.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Intelligent machines,” Halleck muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Aditi spoke up. “Our Predecessors. They created New Earth and my people. They have visited your Earth many times.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I find that hard to believe,” one of the other Council members challenged. “Our best robots are hardly what I would call intelligent. They have no self-awareness, no … no divine spark.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We’re not here to debate philosophy,” snapped the woman sitting beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Aditi explained, “Organic life is finite. All organic species become extinct, sooner or later. But some intelligent organic species develop inorganic intelligence. Machine intelligence can be virtually immortal.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Silence fell around the table.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Machine intelligence has superseded organic intelligence in many parts of the universe,” Jordan explained. “One day, I suppose, intelligent, self-maintaining machines will become our descendants.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For long moments no one spoke a word. Then Rudaki shook his head and said, “You don’t understand. I don’t care if they were intelligent machines or intellectual rocks.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Then what—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Rudaki asked, “How can their observations of the gamma wave get here before the wave itself does? How can the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("information")]), _vm._v(" travel faster than the wave itself?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan saw perplexed looks on the faces of most of the Council members.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His brow furrowing, the astrophysicist explained, “Observers ten thousand light-years closer to the core of the Milky Way observe the gamma wave, yes? Their information of that phenomenon should take ten thousand years to reach us here, if their communications are limited to the speed of light, as ours are.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Halleck understood. “You’re saying that the aliens must have some form of communication that moves information faster than light.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes,” Rudaki said emphatically. Looking at Jordan, he asked, “What have they told you about their communications technology?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Not very much,” Jordan admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Not much?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Feeling embarrassed, little short of dim-witted, Jordan said, “The question barely came up. Even your daughter didn’t delve into it very deeply. There was so much else to do, to discover…”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Halleck looked at Aditi. “What can you tell us about your communications technology?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Aditi shrugged. “Very little, I’m afraid. I’m not trained in that area. But I can ask our leaders back on New Earth about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And wait sixteen years to get their answer,” grumbled one of the councilmen from down the table.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh no,” Aditi said. “It should only take an hour or so.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("That sent a shock wave through the conference room.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Then you "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("do")]), _vm._v(" have access to faster-than-light communications!” Halleck snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her facial expression somewhere between surprised and wounded, Aditi replied, “Yes, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You can communicate with Adri, back on New Earth?” Jordan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nodding slowly, Aditi said, “When I have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The holographic image of George Ambrose ran a hand through his shaggy red mane. “That means I can attend these bloody meetings from Ceres, ’stead of riding clear to the Moon for ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We could link the entire solar system into a single human community!” marveled one of the Council members.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("With a thin smile, Halleck mused, “We can turn this council into a truly effective government for the whole solar system.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Now wait,” warned Stavenger’s hologram. “Selene is a free nation. We attend these Council meetings as an independent entity.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan saw the dreams of power and control in the eyes of most of the men and women around the table, especially Halleck’s. And he realized that Aditi saw it, too. She looked shocked, crestfallen.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Virtually instantaneous communications,” Halleck purred. “This could open an entirely new era for the human race.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Wait,” Jordan said, raising his voice to silence the buzz going around the table. “We still have to decide what to do about the death wave.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s not going to be a problem for two thousand years, Jordan,” said Halleck. “We have more immediate priorities to deal with.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Damming up the meltwater flow from Greenland is our first priority,” said one of the councilmen.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But there are planets that will be engulfed in the death wave much sooner,” Jordan urged. “We’ve got to help them. If we don’t, whole civilizations will be annihilated.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“All in good time,” Halleck said. “First things first.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f2e68b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 93
// module chunks = 0